import { Col, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import "./GanttView.css";

export default function Legend() {
  const { t } = useTranslation();

  return (
    <>
      <Row className={"mb-10"}>
        <Col span={12}>
          <Row justify="start">
            <Col>
              <div className={"supplierTaskColorLegend mr-10"} />
            </Col>
            <Col span={12}>{t("projectsManagement.planning.ganttChart.supplierTask")}</Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row justify="start">
            <Col>
              <div className={"internalTaskColorLegend  mr-10"} />
            </Col>
            <Col span={12}>{t("projectsManagement.planning.ganttChart.internalTask")}</Col>
          </Row>
        </Col>
      </Row>
      <Row className={"mb-10"}>
        <Col span={12}>
          <Row justify="start">
            <Col>
              <div className={"clientTaskColorLegend  mr-10"} />
            </Col>
            <Col span={12}>{t("projectsManagement.planning.ganttChart.clientTask")}</Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row justify="start">
            <Col>
              <div className={"milestoneColorLegend  mr-10"} />
            </Col>
            <Col span={12}>{t("projectsManagement.planning.ganttChart.milestone")}</Col>
          </Row>
        </Col>
      </Row>
      <Row className={"mb-10"}>
        <Col span={12}>
          <Row justify="start">
            <Col>
              <div className={"kickOffColorLegend  mr-10"} />
            </Col>
            <Col span={12}>{t("projectsManagement.planning.ganttChart.kickOff")}</Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row justify="start">
            <Col>
              <div className={"groupingViewColorLegend  mr-10"} />
            </Col>
            <Col span={12}>{t("projectsManagement.planning.ganttChart.groupingView")}</Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
